export const LOGIN = 'LOGIN';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const ERROR_SERVER = 'ERROR_SERVER';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const UNATORIZED = 'UNATORIZED'
export const CLEAR_ALERTS = 'CLEAR_ALERTS'
export const LOGIN_LOADING = 'LOGIN_LOADING'